import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./reducers"; // Import your combined reducers here
import { offerSlice } from "./store/app/dmiofferSlice";
import { aaSlice } from "./store/app/aaSlice";


const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV === "development",
  offers:offerSlice.reducer,
 
});

export default store;
